
(() => {
  const INTERVAL = 3500; // Total time allotted to each slide, in ms
  const FADE = 500;      // Dissolve duration, in ms
  const STYLE_ID = 'dynamic-slideshow-animation';

  function setupSlideshow() {
    const slideshow = document.querySelector(
      'main[data-template="index"] slideshow-component'
    );

    if (!slideshow) return;

    const slides = Array.from(
      slideshow.querySelectorAll('.slideshow__slide')
    ).filter((slide) => slide.getClientRects().length > 0);

    const count = slides.length;

    if (!count) return;

    // One shared animation cycle, regardless of slide count.
    const totalDuration = count * INTERVAL;
    const fadeEnd = (FADE / totalDuration) * 100;
    const intervalEnd = (INTERVAL / totalDuration) * 100;
    const nextSlideEnd = ((INTERVAL + FADE) / totalDuration) * 100;

    let style = document.getElementById(STYLE_ID);

    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      document.head.appendChild(style);
    }

    style.textContent = `
      @keyframes slide-dissolve {
        0% {
          opacity: 0;
          z-index: 2;
        }

        ${fadeEnd}% {
          opacity: 1;
          z-index: 2;
        }

        ${intervalEnd}% {
          opacity: 1;
          z-index: 2;
        }

        ${intervalEnd + 0.01}% {
          opacity: 1;
          z-index: 1;
        }

        ${nextSlideEnd}% {
          opacity: 1;
          z-index: 1;
        }

        ${nextSlideEnd + 0.01}% {
          opacity: 0;
          z-index: 1;
        }

        100% {
          opacity: 0;
          z-index: 1;
        }
      }
    `;

    slides.forEach((slide, index) => {
      slide.style.setProperty(
        '--slide-total-duration',
        `${totalDuration}ms`
      );

      slide.style.setProperty(
        '--slide-animation-delay',
        `${index * INTERVAL}ms`
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupSlideshow);
  } else {
    setupSlideshow();
  }

  // Recalculate when slides are added or removed in the theme editor.
  document.addEventListener('shopify:section:load', setupSlideshow);
  document.addEventListener('shopify:section:reorder', setupSlideshow);
})();
